module.exports = __webpack_public_path__ + "img/couples-034.b7e29558.jpg";